import React from 'react';

import { Button, Divider } from '@mui/material';

import classes from './SuccessfulResult.module.scss';
import { PaymentResultsInbodyBlock } from '../../../../inbody';
import { ResultTitle } from '../../../components/payment-result/ResultTitle/ResultTitle';
import { PaymentDetails } from '../../../components/payment-result/PaymentDetails/PaymentDetails';
import { PaymentInfo } from '../../../interfaces/paymentResult';
import { getPaymentResultParams } from '../../../utils/getPaymentResultParams';

type SuccessfulResultProps = {
  paymentInfo: PaymentInfo | null;
  retryPath: string;
};

const SuccessfulResult = ({ paymentInfo, retryPath }: SuccessfulResultProps) => {
  const { entityId } = getPaymentResultParams();

  return (
    <div className={classes.container}>
      {paymentInfo && (
        <>
          <div className={classes.paymentInfo}>
            <ResultTitle isSuccessful title="1. Payment Complete" />
            <PaymentDetails paymentInfo={paymentInfo} />
          </div>
          <Divider />
        </>
      )}
      {entityId && (
        <PaymentResultsInbodyBlock
          title={`${paymentInfo ? '2.' : '1.'} Complete Your InBody Scan`}
          entityId={entityId}
        />
      )}
      <Button variant="outlined" href={`#!${retryPath}`}>
        Finish
      </Button>
    </div>
  );
};

export { SuccessfulResult };
